import { Component, Input } from '@angular/core';
import { TUploadResponseDTO } from '@monorepo/services';
import { ExcelManagementFacade } from '../../../../redux-store/excel-management/excel-management.facade';
import { TExcelManagementInfo } from '../../../../types';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'monorepo-upload-summary-modal',
  templateUrl: './upload-summary-modal.component.html',
  styleUrls: ['./upload-summary-modal.component.scss'],
})
export class UploadSummaryModalComponent {
  @Input() excelInfo?: TExcelManagementInfo = undefined;
  @Input() summary: TUploadResponseDTO = {
    totalProcessedRows: 0,
    successfulRows: 0,
    failedRows: 0,
    errors: 0,
  };

  constructor(private excelManagementFacade: ExcelManagementFacade, private modalController: ModalController) {}

  onDownloadErrorFile() {
    const errorFileKeyOpt = this.summary?.errorFileKeyOpt;
    const excelContext = this.excelInfo?.excelContext;
    if (errorFileKeyOpt && excelContext && this.excelInfo?.hasExcelErrorTemplate) {
      this.excelManagementFacade.downloadErrorTemplate(errorFileKeyOpt, excelContext);
      this.dimissModal();
    }
  }

  dimissModal() {
    this.modalController.dismiss();
  }
}
